import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Counter from '../Counter';
import IdList from './IdList';
import WalletLegalIdCard from '../wallet/WalletLegalIdCard';
import WalletLegalIdDetailModal from '../wallet/WalletLegalIdDetailModal';
import IdProps from '../../proptypes/id';
import IdIcon from '../../img/icons/id.svg';
import style from '../../style/components/overview/Ids.module.scss';

const Ids = ({ active, expired }) => {
  const { t } = useTranslation();
  const countryWorkProfile = useSelector(
    (state) => state.featureFlags.countryWorkProfile,
  );
  const inlineEmailEdit = useSelector(
    (state) => state.featureFlags.inlineEmailEdit,
  );

  const legalIds = useSelector((state) => state.countryWorkProfile.legalIds);
  // Flags alone aren't enough to gate rendering: showCredentials && (<div>
  // {legalIds.map(...)}</div>) is still a truthy (non-empty) element even
  // when legalIds is empty, so IdList's `children &&` check would still
  // render its wrapping <li> -- an empty one, but still carrying
  // .idCardFanned's large negative margin, collapsing space onto the
  // previous card.
  const showCredentials =
    countryWorkProfile && inlineEmailEdit && legalIds.length > 0;
  const [selectedDocIndex, setSelectedDocIndex] = useState(null);

  return (
    <article className={style.ids}>
      <div className={style.title}>
        <h3>
          <img alt="ID icon" src={IdIcon} />
          {t('overview.myIds')}
        </h3>
        <Counter>
          {t('overview.activeCount', {
            count: active.length + (showCredentials ? legalIds.length : 0),
          })}
        </Counter>
      </div>
      <IdList active={active} expired={expired}>
        {showCredentials && (
          <div className={style.legalIdCards}>
            {legalIds.map((doc, index) => (
              <WalletLegalIdCard
                key={doc.kind}
                variant={doc.kind}
                onClick={() => setSelectedDocIndex(index)}
                showCardHolderName
              />
            ))}
          </div>
        )}
      </IdList>
      {showCredentials && selectedDocIndex !== null && (
        <WalletLegalIdDetailModal
          documents={legalIds}
          selectedIndex={selectedDocIndex}
          isOpen
          onClose={() => setSelectedDocIndex(null)}
          onNavigate={setSelectedDocIndex}
        />
      )}
    </article>
  );
};

Ids.propTypes = {
  active: PropTypes.arrayOf(PropTypes.shape(IdProps)),
  expired: PropTypes.arrayOf(PropTypes.shape(IdProps)),
};

Ids.defaultProps = {
  active: [],
  expired: [],
};

export default Ids;
